import { render, staticRenderFns } from "./PaymentSetup.vue?vue&type=template&id=7aa80c4e&scoped=true&slot-scope=scope&"
import script from "./PaymentSetup.vue?vue&type=script&lang=js&"
export * from "./PaymentSetup.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSetup.vue?vue&type=style&index=0&id=7aa80c4e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa80c4e",
  null
  
)

export default component.exports